<template>
  <!-- <div class="zt-container"> 


  </div> -->

  <div class="container">
    <!-- 顶部标题区域 -->
    <div class="header">
      <div class="title-section">
        <van-icon name="fire-o" size="24" color="white" />
        <span class="title-text">待分配菜品</span>
      </div>
      <van-tag class="info-tag">{{ summaryText }}</van-tag>
    </div>

    <!-- 菜品表格区域 -->
    <div class="table">
      <!-- 表头 -->
      <div class="table-header">
        <div class="header-cell dish-header">菜品名称</div>
        <div class="header-cell">桌位</div>
        <div class="header-cell">份数</div>
        <div class="header-cell">时间</div>
        <div class="header-cell">操作</div>
      </div>

      <!-- 表格内容 -->
      <div
        v-for="(item, index) in tableData"
        :key="index"
        class="table-row"
        :class="{ 'urgent-row': item.isUrgent }"
      >
        <!-- 菜品名称列 - 修改后的布局 -->
        <div class="table-cell dish-cell">
          <div class="dish-info">
            <span class="dish-name">{{ item.name }}</span>
            <div class="tags">
              <!-- 菜品类型标签 -->
              <van-tag v-if="item.type" :class="getTypeClass(item.type)" class="type-tag">
                {{ item.type }}
              </van-tag>
              <!-- 加急标签 -->
              <van-tag v-if="item.isUrgent" class="urgent-tag">加急</van-tag>
            </div>
          </div>
        </div>

        <!-- 桌位列 -->
        <div class="table-cell">{{ item.location }}</div>

        <!-- 份数列 -->
        <div class="table-cell">{{ item.portions }}份</div>

        <!-- 时间列 -->
        <div class="table-cell">{{ item.time }}</div>

        <!-- 操作列 -->
        <div class="table-cell">
          <van-button class="assign-btn" size="small" @click="handleAssignClick(item)"
            >分配</van-button
          >
        </div>
      </div>
    </div>
  </div>

  <!-- 分配模态框 -->
  <van-dialog
    v-model:show="showAssignModal"
    class="assign-modal"
    title="选择分配灶台"
    :title-align="'left'"
    :closeable="true"
    :show-cancel-button="false"
    :show-confirm-button="false"
    teleport="body"
    :style="{ zIndex: 9999, width: '50%', textAlign: 'left !important' }"
    :mask="true"
    message-align="left"
    @open="handleDialogOpen"
  >
    <div class="modal-content">
      <div class="dish-container">
        <div class="dish-title">
          <span class="dish-name">{{ currentDish?.name }}</span>
          <span class="dish-location">{{ currentDish?.location }}</span>
        </div>
        <div class="quantity-control">
          <span class="quantity-label">分配数量：</span>
          <div class="stepper-container">
            <van-stepper
              v-model="assignQuantity"
              class="stepper"
              :min="1"
              :max="currentDish?.portions || 1"
              button-size="32"
            />
          </div>
          <span class="quantity-total">/共{{ currentDish?.portions || 0 }}份</span>
        </div>
      </div>

      <!-- 灶台列表 -->
      <div class="stoves-list">
        <van-grid :border="false" :column-num="2" direction="horizontal" style="padding-left: 0">
          <van-grid-item v-for="stove in stovesData" :key="stove.id" class="stove-item">
            <div class="stove-content">
              <div class="stove-name">{{ stove.name }}</div>
              <div class="stove-status"
                >队列{{ stove.assignedTasks }}/{{ stove.availableTasks }}</div
              >
            </div>
          </van-grid-item>
        </van-grid>
      </div>
    </div>
  </van-dialog>
</template>

<script setup lang="ts">
  import { ref, computed } from 'vue';
  import { DishItemNewModel, StoveItemModel } from '../model/kitchen';

  // 模态框状态
  const showAssignModal = ref(false);
  const currentDish = ref<DishItemNewModel | null>(null);
  const assignQuantity = ref(1);

  // 接收父组件传递的数据（使用模拟数据作为默认值）
  const props = withDefaults(
    defineProps<{
      tableData?: DishItemNewModel[];
      stovesData?: StoveItemModel[];
    }>(),
    {
      tableData: () => [],
      stovesData: () => [],
    },
  );

  // 分配按钮点击事件
  const handleAssignClick = (dish: DishItemNewModel) => {
    console.log('分配按钮点击事件', dish);
    currentDish.value = dish;
    assignQuantity.value = 1;
    showAssignModal.value = true;
    console.log('分配弹窗状态:', showAssignModal.value);
  };

  // 弹窗打开事件
  const handleDialogOpen = () => {
    console.log('弹窗已打开');
  };

  // 计算总菜品和总份数
  const summaryText = computed(() => {
    const dishCount = props.tableData?.length || 0;
    const portionCount = props.tableData?.reduce((sum, item) => sum + item.portions, 0) || 0;
    return `${dishCount}道菜品，${portionCount}份`;
  });

  // 根据菜品类型获取对应的CSS类
  const getTypeClass = (type: string) => {
    switch (type) {
      case '热菜':
        return 'hot-tag';
      case '冷菜':
        return 'cold-tag';
      case '点心':
        return 'dim-sum-tag';
      case '饮品':
        return 'drink-tag';
      default:
        return '';
    }
  };
</script>

<style scoped lang="less">
  .zt-container {
    width: 50%;
    height: 100vh;
    padding: 16px;
  }
  .container {
    width: 50%;
    height: 100vh;
    padding: 16px;
    box-sizing: border-box;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .title-section {
    display: flex;
    align-items: center;
    gap: 8px;

    .title-text {
      font-size: 20px;
      font-weight: bold;
      color: white;
      text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
    }
  }

  .info-tag {
    background-color: white;
    color: #9f9fa4;
    font-size: 14px;
    border-radius: 12px;
    padding: 4px 12px;
  }

  .table {
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .table-header {
    display: flex;
    background-color: #f0f0f0;
    padding: 12px 0;
    font-weight: bold;
    color: black;
    font-size: 16px;

    .header-cell {
      flex: 1;
      text-align: center;
      padding: 0 8px;

      &.dish-header {
        flex: 2; /* 菜品名称列宽度加倍 */
      }
    }
  }

  .table-row {
    display: flex;
    border-bottom: 1px solid #eee;
    padding: 12px 0;
    position: relative;

    // 加急行的样式
    &.urgent-row {
      background-color: #fef6f5;

      // 左侧红色粗线
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background-color: red;
      }
    }
  }

  .table-cell {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 8px;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.dish-cell {
    flex: 2; /* 菜品名称列宽度加倍 */
    justify-content: flex-start; /* 内容靠左对齐 */
  }

  /* 修改后的菜品信息布局 */
  .dish-info {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-left: 8px;
    width: 100%;
  }

  .dish-name {
    font-weight: 500;
    white-space: nowrap; /* 防止名称换行 */
    overflow: hidden;
    text-overflow: ellipsis; /* 过长时显示省略号 */
    max-width: 60%; /* 名称最大宽度 */
  }

  .tags {
    display: flex;
    gap: 4px;
    flex-wrap: nowrap; /* 标签不换行 */
  }

  .type-tag,
  .urgent-tag {
    font-size: 12px;
    border-radius: 4px;
    padding: 2px 8px;
    color: white;
    white-space: nowrap; /* 标签不换行 */
  }

  .hot-tag {
    background-color: #f19a37;
  }

  .cold-tag {
    background-color: #78c6f5;
  }

  .dim-sum-tag {
    background-color: #65c466;
  }

  .drink-tag {
    background-color: #3478f6;
  }

  .urgent-tag {
    background-color: red;
    border-radius: 3px;
  }

  .assign-btn {
    background-color: #3498db;
    color: white;
    border-radius: 4px;
    font-size: 14px;
    padding: 4px 12px;
    border: none;
  }

  /* 分配模态框样式 */
  .assign-modal {
    .van-dialog__content {
      padding: 16px;
      background-color: white;
    }

    .assign-modal ::v-deep .van-dialog__title {
      font-size: 24px !important;
      color: #000 !important;
      font-weight: bold !important;
      text-align: left !important;
      padding: 8px 0 16px !important;
      border-bottom: 1px solid #e5e5ea !important;
      margin-bottom: 16px !important;
    }

    .van-dialog__mask {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }

  .modal-content {
    padding: 18px;
  }

  .dish-container {
    background-color: #f2f2f7;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
  }

  .dish-title {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
  }

  .dish-name {
    font-weight: bold;
    font-size: 16px;
    color: #000;
    margin-right: 8px;
  }

  .dish-location {
    font-size: 14px;
    color: #97979c;
  }

  .quantity-control {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .quantity-label {
    font-size: 14px;
    color: #97979c;
    margin-right: 8px;
  }

  .stepper-container {
    background-color: white;
    border: 1px solid #fcfcfc;
    border-radius: 4px;
    padding: 20px;
    display: flex;
    justify-content: center;
  }

  .stepper {
    width: 180px; /* 增加整体宽度 */
    // margin-right: 8px;

    ::v-deep .van-stepper__minus,
    ::v-deep .van-stepper__plus {
      background-color: #3498db;
      color: white;
      width: 36px; /* 增大按钮宽度 */
      height: 36px; /* 增大按钮高度 */
      margin: 0 16px; /* 增加按钮间距 */
      border-radius: 4px; /* 保持圆角 */
    }

    ::v-deep .van-stepper__input {
      font-size: 20px; /* 增大字体大小 */
      font-weight: bold;
      color: #000;
      width: 30px; /* 增加输入框宽度 */
      padding: 0 8px; /* 增加内边距 */
      background-color: white;
    }
  }

  .quantity-total {
    font-size: 14px;
    color: #929297;
    font-weight: bold;
    margin-left: 20px;
  }

  // .stoves-list {
  //   margin-top: 16px;
  // }

  .stove-item {
    background-color: white;
    // border: 3px solid #e5e5ea;
    // border-radius: 8px;
    // padding: 12px;
  }

  .stove-content {
    text-align: center;
    border: 3px solid #e5e5ea;
    width: 100%;
    border-radius: 18px;
    // padding: 12px;
    padding-top: 15%;
    padding-bottom: 15%;
  }

  .stove-name {
    font-size: 23px;
    font-weight: bold;
    margin-bottom: 4px;
  }

  .stove-status {
    font-size: 21px;
    color: #97979c;
  }

  .assign-btn {
    background-color: #3498db;
    color: white;
    border-radius: 4px;
    font-size: 14px;
    padding: 4px 12px;
    border: none;
  }

  .van-dialog__header {
    text-align: left !important;
  }
</style>

<style lang="less">
  /* 全局样式 - 针对teleport到body的对话框 */
  .van-dialog.assign-modal .van-dialog__header {
    font-size: 26px !important;
    color: #000 !important;
    font-weight: bold !important;
    text-align: left !important;
    padding: 8px 16px 16px !important;
    border-bottom: 1px solid #e5e5ea !important;
    margin-bottom: 16px !important;
  }
</style>
